// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** True inside the desktop app (Tauri), where local vaults, the keychain, and menus exist. */
export const isDesktop = import.meta.env.VITE_PLATFORM === "desktop";

/**
 * The macOS desktop app draws no title bar (P4-T01): the page runs to the top of the window
 * and the window buttons float over its top-left corner. main.tsx marks <html
 * data-titlebar="overlay">, which the `titlebar:` style variant keys on.
 */
export const overlayTitleBar = isDesktop && /Macintosh|Mac OS X/.test(navigator.userAgent);

/**
 * True on a Mac, where "Continue with Apple" is offered (P1-T02): the web app in a Mac browser
 * and the macOS desktop app. Not on an iPhone, nor on an iPad, whose Safari asks for the Mac
 * site (it says "Macintosh" but has a touch screen). userAgentData answers where it exists
 * (Chromium); elsewhere the user agent does.
 */
export function isMac(nav: Navigator = navigator): boolean {
  const n = nav as Navigator & { userAgentData?: { platform?: string } };
  if (n.userAgentData?.platform) return n.userAgentData.platform === "macOS";
  if (!/Macintosh|Mac OS X/.test(n.userAgent) || /iPhone|iPad|iPod/.test(n.userAgent)) return false;
  return n.maxTouchPoints <= 1;
}
